import { render, staticRenderFns } from "./wizard-rates.vue?vue&type=template&id=5fb914e0&scoped=true&lang=pug"
import script from "./wizard-rates.vue?vue&type=script&lang=ts"
export * from "./wizard-rates.vue?vue&type=script&lang=ts"
import style0 from "./wizard-rates.vue?vue&type=style&index=0&id=5fb914e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb914e0",
  null
  
)

export default component.exports